import PropTypes from 'prop-types';
import React from 'react';
import {NavLink, useHistory} from 'react-router-dom';
import LinkBuilder from '../../../../helpers/link-builder';
import CompanyLogo from '../../../CompanyLogo';
import RatingPoll from '../../../RatingPoll';
import './styles.css';

const FirmCarouselSlide = props => {
  const {
    data: {
      FirmID,
      FirmName,
      UrlAlias,

      Logo,
      Rating,
      ResponsesCount,
      ShowRating,
      disabled = false,
    },
    onRatingUpdate,
    onBeforeRatingUpdate,
  } = props;

  const history = useHistory();

  const link = LinkBuilder.getFirmLink(UrlAlias);

  const handleRatingUpdate = mark => {
    !disabled && onRatingUpdate(FirmID, mark);
  };

  const handleBeforeRatingUpdate = () => {
    return !disabled && onBeforeRatingUpdate();
  };

  const handleClickLink = () => {
    history.push(LinkBuilder.getFirmTabReviewLink(UrlAlias));
  };

  return (
    <div className="firm-carousel-slide">
      <div className="firm-carousel-slide__body">
        <div className="firm-carousel-slide__logo">
          <CompanyLogo
            name={FirmName}
            logo={Logo}
            link={link}
            styles={{
              width: '110px',
              height: '110px',
              fontSize: '0.9286rem',
            }}
          />
        </div>
        <div className="firm-carousel-slide__content">
          <NavLink to={link} className="firm-carousel-slide__name">
            {FirmName}
          </NavLink>
          <div className="firm-carousel-slide__rating">
            <RatingPoll
              showRating={ShowRating === 'Yes'}
              count={Number(ResponsesCount)}
              rating={Number(Rating)}
              onLinkClickHandler={handleClickLink}
              onRatingUpdateHandler={handleRatingUpdate}
              onBeforeRatingUpdateHandler={handleBeforeRatingUpdate}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

FirmCarouselSlide.propTypes = {
  data: PropTypes.shape({
    FirmID: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
      .isRequired,
    FirmName: PropTypes.string.isRequired,
    UrlAlias: PropTypes.string.isRequired,
    Logo: PropTypes.string,
    Rating: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    ResponsesCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    ShowRating: PropTypes.oneOf(['Yes', 'No']),
    disabled: PropTypes.bool,
  }),
  onRatingUpdate: PropTypes.func.isRequired,
  onBeforeRatingUpdate: PropTypes.func.isRequired,
};

export default FirmCarouselSlide;
